import { Container, Row, Col  } from 'react-bootstrap';
import TypeAnimation from 'react-type-animation';
import SkillContainer from './SkillContainer';
import projects from '../data/projects';

export default function Projects() {

	const allProjects = projects.map(project => {
        return (
        	<Col xs={12} lg={4} md={6}>
            	<SkillContainer key={project.id}  projects={project} />
            </Col>
        );
	}); 
	return(
		<Container id="projects" className="mb-5 mt-5">
		    <TypeAnimation
		   	    cursor={false}
		   	    sequence={[ 
		   	       'Webseite', 1000, 
		   	       'Web Projects', 1000, 
		   	       'Static Websites', 1000, 
		   	       'Dynamic Websites', 1000, 
		   	       'Projekte', 1000, 
		   	       'Projects', 1000]}
		   	    wrapper="p"
		   	    className="about-me-label mt-1 text-center mb-4"
		    />

	    	<Row>
	       		{allProjects}
	       	</Row>
		</Container>
	);
}